import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { DealerParams } from "@shared/model/dealer.model";
import { UserDTO } from "@shared/model/user.model";
import { CT } from "@shared/services/code-table/code-table.model";
import { CodeTableService } from "@shared/services/code-table/code-table.service";
import { UsersService } from "@shared/services/users/users.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";

@Component({
	selector: "app-dealer-search",
	templateUrl: "./dealer-search.component.html",
	styleUrl: "./dealer-search.component.scss",
	standalone: false
})
export class DealerSearchComponent implements OnInit {
	dealerSearchForm: UntypedFormGroup = new UntypedFormGroup(
		{
			idDealer: new UntypedFormControl("", Validators.pattern("^\\d+$")),
			businessName: new UntypedFormControl(""),
			username: new UntypedFormControl(""),
			vatCode: new UntypedFormControl(""),
			area: new UntypedFormControl(""),
			country: new UntypedFormControl("")
		}
	);
	@Output()
	dealers: EventEmitter<DealerParams> = new EventEmitter<DealerParams>();
	expanded = true;
	countries: any;
	country: any;
	user: UserDTO;
	markets;

	constructor(
		private codeTableService: CodeTableService,
		private userService: UsersService,
		public utils: ClickarUtilsService
	) { }

	ngOnInit() {
		this.userService.getProfileOfLoggedUser().subscribe(value => {
			this.user = value;
			this.markets = this.user.adminEnabledMarket.filter(value1 => value1 !== "OTHER");
		});

		this.codeTableService.getCTElementsUsingGET(CT[CT.COUNTRY], this.utils.getPreferredLanguage()).subscribe(value => {
			this.countries = value;
		});
	}

	search() {
		this.expanded = !this.expanded;

		const dealerParams: DealerParams = this.dealerSearchForm.getRawValue();
		this.dealers.emit(dealerParams);
	}
}